<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1" >
                <v-col cols="3" justify="center" align="center" class="py-0">
                    <client-selector :addAllOption="false" :full_catalog="true" :guides_service="true" class="py-0 my-0 " ref="clientSelector" @getClients="v => items.clients = v"></client-selector>  
                </v-col>
                <v-col cols="2" class="my-0 py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('products.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-row class="mx-0 my-0 px-0 py-0" justify="end">
                        <v-tooltip bottom v-permission="'guides.create'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="right tools-view-height mx-1" color="secondary" outlined @click="modal_massive = true" style="max-width: 40px !important; min-width: 40px !important" >
                                    <v-icon class="material-icons-outlined" small>cloud_upload</v-icon>
                                </v-btn>
                            </template>

                            <span>{{$t('guides.create_csv')}}</span>
                        </v-tooltip>

                        <v-tooltip bottom v-permission="'guides.refresh'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="right tools-view-height mx-1" color="secondary" outlined @click="updateGuides" style="max-width: 40px !important; min-width: 40px !important" >
                                    <v-icon class="material-icons-outlined" small>autorenew</v-icon>
                                </v-btn>
                            </template>

                            <span>{{$t('guides.refresh')}}</span>
                        </v-tooltip>

                        <v-tooltip bottom v-permission="'guides.update'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="right tools-view-height mx-1" :disabled="tab != 0" outlined color="error" @click="calculateCancelations" style="max-width: 40px !important; min-width: 40px !important" >
                                    <v-icon class="material-icons-outlined" small>cancel</v-icon>
                                </v-btn>
                            </template>

                            <span>{{$t('guides.cancel_guides')}}</span>
                        </v-tooltip>

                        <v-tooltip bottom v-permission="'guides.delete'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="right tools-view-height mx-1" :disabled="tab != 0" outlined color="error" @click="calculateDeletions" style="max-width: 40px !important; min-width: 40px !important" >
                                    <v-icon class="material-icons-outlined" small>delete</v-icon>
                                </v-btn>
                            </template>

                            <span>{{$t('guides.delete_selected')}}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="right white_highlight--text tools-view-height mx-1" color="secondary" @click="downloadLabels" style="max-width: 40px !important; min-width: 40px !important" >
                                    <v-icon class="material-icons-outlined" small>label</v-icon>
                                </v-btn>
                            </template>

                            <span>{{$t('guides.download_guides')}}</span>
                        </v-tooltip>
                    </v-row>
                </v-col>
            </v-row>

             <v-card class="px-0 top_bar mb-3">
                <v-card-text class="py-0 my-0">
                    <v-row class="px-0 py-0 my-0" style="max-height: 43px !important; min-height: 43px !important;" align="center">
                        <v-col cols="8" class="py-0 my-0 px-0">
                            <v-tabs v-model="tab"  active-class="customers_active_tab" style="max-height: 43px !important;">
                                <v-tabs-slider class="slider" color="secondary" style="margin: 0px !important;"></v-tabs-slider>
                                <v-tab v-for="item in tab_items" :key="item" class="non_selected_tab slider" style="max-height: 43px !important;">
                                    {{ item }}
                                </v-tab>
                            </v-tabs>
                        </v-col>
                        
                        <v-spacer></v-spacer>
                    </v-row>
                </v-card-text>
            </v-card> 
            <v-tabs-items v-model="tab" class="px-0 mx-3" >
                <v-tab-item class="px-0 mx-0">
                    <v-card class="size_tab mx-0 px-0" flat>
                        <v-card-text class="px-0 mx-1">
                            <v-row class="px-0 mx-0">
                                <v-col class="py-0 px-0 mx-0">
                                    <datatable :key="'table1-' + tab" show-select v-model="items_selected_created" :pagination="[20, 50, 100, 200]" :props="{ headers: headers, items: props.items, search: props.search}" :itemsLength="props.meta.total" :options.sync="pagination.pendings" @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"></datatable>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item class="px-0 mx-0">
                    <v-card class="size_tab mx-0 px-0" flat>
                        <v-card-text class="px-0 mx-1">
                            <v-row>
                                <v-col class="py-0">
                                    <datatable :key="'table2-' + tab" show-select v-model="items_selected_in_transit" :pagination="[20, 50, 100, 200]" :props="{ headers: headers, items: props.items, search: props.search}" :itemsLength="props.meta.total" :options.sync="pagination.in_transit" @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"></datatable>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                
                <v-tab-item class="px-0 mx-0">
                    <v-card class="size_tab mx-0 px-0" flat>
                        <v-card-text class="px-0 mx-1">
                            <v-row>
                                <v-col class="py-0">
                                    <datatable :key="'table3-' + tab" show-select v-model="items_selected_delivered" :pagination="[20, 50, 100, 200]" :props="{ headers: headers, items: props.items, search: props.search}" :itemsLength="props.meta.total" :options.sync="pagination.delivered" @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"></datatable>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item class="px-0 mx-0">
                    <v-card class="size_tab mx-0 px-0" flat>
                        <v-card-text class="px-0 mx-1">
                            <v-row>
                                <v-col class="py-0">
                                    <datatable :key="'table4-' + tab" show-select v-model="items_selected_returned" :pagination="[20, 50, 100, 200]" :props="{ headers: headers, items: props.items, search: props.search}" :itemsLength="props.meta.total" :options.sync="pagination.returned" @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"></datatable>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-tab-item> 
            </v-tabs-items>

        </v-container>
        <v-dialog v-model="modal_massive" persistent max-width="90%" >
            <v-card style="min-width: 500px">
            <v-card-title class="justify-center">
                {{ $t('guides.create_multiple_guides') }}
            </v-card-title>
                <v-stepper v-model="stepper">
                    <v-stepper-items>
                        <v-stepper-content step="1" class="mx-0 px-0">
                            <v-card class="">
                                <v-form ref="form2" lazy-validation>
                                    <v-row class="mx-0 px-0 pt-8" justify="center" align="center">
                                        <v-col cols="11" class="py-0 my-0 px-5">
                                        <client-selector class="py-0" ref="clientSelector" @getClients="v => items.clients = v" :rules="rules_required" :full_catalog="true" :guides_service="true"></client-selector>  
                                        </v-col>
                                    </v-row>
                                    <v-row class="px-5 py-0" justify="center" align="center">
                                        <v-col cols="11" class="py-0 my-0">
                                            <v-autocomplete class="py-0 mt-0" v-model="guide.shipping_guide.pickup_address_id" :items="addresses" :label="$t('guides.addresses')" :loading="load_addresses" item-value="id" item-text="address.direction" :rules="rules_required"></v-autocomplete> 
                                        </v-col>
                                    </v-row>
                                    <v-row class="px-5 py-0" justify="center" align="center">
                                        <v-col cols="11" class="py-0 my-0">
                                            <v-autocomplete class="py-0 mt-0" v-model="guide.shipping_guide.subclient_id" :items="subclients" :label="$t('guides.subclients')" :loading="load_subclients" item-value="id" item-text="attributes.name" :rules="rules_required"></v-autocomplete> 
                                        </v-col>
                                    </v-row>
                                    <v-row class="mx-0 px-0" justify="center" align="center">
                                        <v-col cols="10">
                                            <v-file-input v-model="inputFile" color="secondary" accept=".csv" :clearable="true" :label="$t('guides.guides_file')" :rules="rules_required"></v-file-input>
                                        </v-col>
                                        <v-col cols="2">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn class="mx-0" small color="secondary" v-bind="attrs" v-on="on" @click="stepper = 4">
                                                        <v-icon class="material-icons-outlined" aria-hidden="false" color="white" small>
                                                            help
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('guides.help') }}</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card>
                            <v-row class="mx-2 px-5 mx-5 py-0" justify="end" align="end">
                                <v-col cols="2" justify="end" align="end" class="mr-12">
                                    <v-btn text  @click="modal_massive = false;" >
                                        {{ $t('guides.cancel') }}
                                    </v-btn>
                                </v-col>
                                <v-col cols="2" justify="end" align="end" class="mr-4">
                                    <v-btn class="white_highlight--text" color="secondary" @click="createWithCsv" >
                                        {{ $t('guides.load') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-stepper-content>

                        <v-stepper-content step="4">
                            <p class="py-0 my-0">1.- Conserve todos los encabezados en el orden presentado y sin modificarlos.</p> 
                            <p class="py-0 my-0">2.- Llene la información de acuerdo al campo solicitado, no utilice comas en ninguno de los campos, evite el uso de signos de interrogación, acentos, comillas o signos de admiración.</p> 
                            <p class="py-0 my-0">3.- A continuación se muestra una línea de ejemplo para familiarizarse con el formato.</p> 
                            <p class="py-0 my-0">4.- El archivo de productos debe ser formato CSV.</p> 
                            <p class="py-0 my-0">5.- El límite máximo de valores que puedes agregar en referencias y costos es de 30 unidades.</p> 
                            <p class="py-0 my-0">Ejemplo: </p>
                            <v-simple-table fixed-header>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left" style="padding: 0 5px !important;">nombre_cliente</th>
                                            <th class="text-left" style="padding: 0 5px !important;">país</th>
                                            <th class="text-left" style="padding: 0 5px !important;">estado</th>
                                            <th class="text-left" style="padding: 0 5px !important;">municipio</th>
                                            <th class="text-left" style="padding: 0 5px !important;">colonia</th>
                                            <th class="text-left" style="padding: 0 5px !important;">domicilio</th>
                                            <th class="text-left" style="padding: 0 5px !important;">codigo_postal</th>
                                            <th class="text-left" style="padding: 0 5px !important;">correo_electronico</th>
                                            <th class="text-left" style="padding: 0 5px !important;">teléfono</th>
                                            <th class="text-left" style="padding: 0 5px !important;">comentarios</th>
                                            <th class="text-left" style="padding: 0 5px !important;">largo</th>
                                            <th class="text-left" style="padding: 0 5px !important;">alto</th>
                                            <th class="text-left" style="padding: 0 5px !important;">ancho</th>
                                            <th class="text-left" style="padding: 0 5px !important;">peso</th>
                                            <th class="text-left" style="padding: 0 5px !important;">referencia</th>
                                            <th class="text-left" style="padding: 0 5px !important;">precio_total</th>
                                            <th class="text-left" style="padding: 0 5px !important;">empresa (opcional)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Pedro García</td>
                                            <td>México</td>
                                            <td>San Luis Potosí</td>
                                            <td>San Luis Potosí</td>
                                            <td>Lomas 4ta Sec</td>
                                            <td>Sierra Leona 418 A</td>
                                            <td>78402</td>
                                            <td>email@email.com</td>
                                            <td>4444444444</td>
                                            <td>Despues de la calle X</td>
                                            <td>25.5</td>
                                            <td>20</td>
                                            <td>6</td>
                                            <td>19.8</td>
                                            <td>ref1|ref2|ref3</td>
                                            <td>152.5|28.7|23.5</td>
                                            <td>Nombre Empresa (opcional)</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                            <v-row align="center" justify="center" class="my-3">
                                <v-btn color="secondary" class="white_highlight--text" @click="stepper = 1">
                                    {{ $t('products.go_back') }}
                                </v-btn>
                            </v-row>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <v-card flat class="mb-5">
                                <v-simple-table v-if="this.responses.length > 0" fixed-header height="300px">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th style="background-color:#c1d500; font-weight:bold !important; color:black !important" class="text-left">{{ $t('customer_fulfillment.order') }}</th>
                                                <th style="background-color:#c1d500; font-weight:bold !important; color:black !important" class="text-left">{{ $t('customer_fulfillment.message') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, i) in responses" :key="i">
                                                <td>{{ item.order }}</td>
                                                <td>{{ item.message }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>

                            <div class="d-flex">
                                <v-btn class="px-3" text @click="stepper = 1; sTHeaders2 = []; readRows2 = []; modal_massive = false; responses = []; loadData()">{{ $t('customer_fulfillment.close') }}</v-btn>
                            </div>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card>
        </v-dialog>
        <v-dialog v-model="modal_delete" persistent max-width="90%" >
            <v-card style="min-width: 500px">
            <v-card-title class="justify-center">
                {{ $t('guides.delete_guides') }}
                <v-spacer></v-spacer>
                <v-btn color="error darken-1" small icon @click="modal_delete = false"><v-icon small>close</v-icon></v-btn>
            </v-card-title>
                <v-stepper v-model="stepper_delete">
                    <v-stepper-items>
                        <v-stepper-content step="1" class="mx-0 px-0">
                            <v-card >
                                <v-card-title class="justify-center">
                                </v-card-title>
                                <v-card-text>
                                    
                                    <v-row align="center" justify="center" class="py-3 my-3 text-center">
                                        <v-col cols="12">
                                            <h3>{{ $t('guides.continue', { number: deletions, customer: $store.state.clientName}) }}</h3>
                                        </v-col>
                                    </v-row>
                                    
                                    <div class="d-flex">
                                        <v-spacer></v-spacer>
                                        <v-btn class="mx-3" text @click="modal_delete = false;">{{ $t('guides.cancel') }}</v-btn>
                                        <v-btn color="error" class="accent" @click="deleteShippingGuidesDetails">
                                            {{ $t('guides.delete') }}
                                        </v-btn>
                                        
                                    </div>
                                </v-card-text> 
                            </v-card>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <v-card flat class="mb-5">
                                <v-simple-table v-if="this.responses.length > 0" fixed-header height="300px">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th style="padding-left: 10px !important; background-color: var(--v-error-base); font-weight:bold !important; color: white !important">{{ $t('customer_fulfillment.message') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, i) in responses" :key="i">
                                                <span v-if="item.code == 200">
                                                    <td>{{ item.success.message }}</td>
                                                </span>
                                                <span v-else-if="item.code == 422">
                                                    <td>{{ item.fault.message }}</td>
                                                </span>
                                                
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>

                            <div class="d-flex">
                                <v-btn class="px-3" text @click="stepper_delete = 1; modal_delete = false; responses = []; loadData(global_status)">{{ $t('customer_fulfillment.close') }}</v-btn>
                            </div>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card>
                    <div class="marker"></div>

        </v-dialog>
        <v-dialog v-model="modal_cancel" persistent max-width="90%" >
            <v-card style="min-width: 500px">
            <v-card-title class="justify-center">
                {{ $t('guides.cancel_guides') }}
                <v-spacer></v-spacer>
                <v-btn color="error darken-1" small icon @click="modal_cancel = false"><v-icon small>close</v-icon></v-btn>
            </v-card-title>
                <v-stepper v-model="stepper_cancel">
                    <v-stepper-items>
                        <v-stepper-content step="1" class="mx-0 px-0">
                            <v-card >
                                <v-card-title class="justify-center">
                                </v-card-title>
                                <v-card-text>
                                    
                                    <v-row align="center" justify="center" class="py-3 my-3 text-center">
                                        <v-col cols="12">
                                            <h3>{{ $t('guides.continue_cancel', { number: cancelations, customer: $store.state.clientName}) }}</h3>
                                        </v-col>
                                    </v-row>
                                    <v-row align="center" justify="center" class="py-3 my-3 text-center">
                                        <v-col cols="12">
                                            <v-text-field class="py-0" v-model="cancel_reason" :label="$t('guides.cancel_reason')"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    
                                    <div class="d-flex">
                                        <v-spacer></v-spacer>
                                        <v-btn class="mx-3" text @click="modal_cancel = false;">{{ $t('guides.cancel') }}</v-btn>
                                        <v-btn color="error" class="accent" :disabled="cancel_reason == ''" @click="cancelShippingGuidesDetails">
                                            {{ $t('guides.cancel_guides') }}
                                        </v-btn>
                                        
                                    </div>
                                </v-card-text> 
                            </v-card>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <v-card flat class="mb-5">
                                <v-simple-table v-if="this.responses.length > 0" fixed-header height="300px">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th style="padding-left: 10px !important; background-color: var(--v-error-base); font-weight:bold !important; color: white !important">{{ $t('customer_fulfillment.message') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, i) in responses" :key="i">
                                                <span v-if="item.code == 200">
                                                    <td>{{ item.success.message }}</td>
                                                </span>
                                                <span v-else-if="item.code == 422">
                                                    <td>{{ item.fault.message }}</td>
                                                </span>
                                                
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>

                            <div class="d-flex">
                                <v-btn class="px-3" text @click="stepper_cancel = 1; modal_cancel = false; responses = []; loadData(global_status)">{{ $t('customer_fulfillment.close') }}</v-btn>
                            </div>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card>
                    <div class="marker"></div>

        </v-dialog>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import {indexByClientGuidesUseCase } from "../application/use_cases/index_by_client_guides_use_case"
import { HttpGuideRepository } from "../infrastructure/repositories/guide_repository";
import { indexSubclientsUseCase } from "../../subclients/application/use_cases/index_subclients_use_case";
import { HttpSubclientRepository } from "../../subclients/infrastructure/repositories/subclient_repository";
import { indexPickupAddressesUseCase } from "../../pickup_addresses/application/use_cases/index_pickup_addresses_use_case";
import { HttpPickupAddressRepository } from "../../pickup_addresses/infrastructure/pickup_address_repository"
import { createGuideUseCase } from "../application/use_cases/create_guide_use_case";
import { downloadGuidesUseCase } from "../application/use_cases/download_guides_use_case";
import { getGuideBlobUseCase } from "../application/use_cases/get_guide_blob_use_case";
import { deleteShippingGuidesUseCase } from "../application/use_cases/delete_shipping_guides_use_case";
import { cancelShippingGuidesUseCase } from "../application/use_cases/cancel_shipping_guides_use_case";

import JSZip from 'jszip';
import FileSaver from 'file-saver';

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('preload.validations.required_field')]}, 
        headers(){
            return [
                { text: this.$t('guides.customer'), align: "center", value: 'client', class: 'text-uppercase' },
                { text: this.$t('guides.reference'), align: "center", value: 'client_reference_id', class: 'text-uppercase' },
                { text: this.$t('guides.date'), align: "center", value: 'date', class: 'text-uppercase' },
                { text: this.$t('guides.guide_number'), align: "center", value: 'tracking_number', class: 'text-uppercase' },
                { text: this.$t('guides.status'), align: "center", value: 'status', class: 'text-uppercase' },
                { text: this.$t('guides.weight'), align: "center", value: 'total_weight', class: 'text-uppercase' },
                { text: this.$t('guides.origin'), align: "center", value: 'origin', class: 'text-uppercase' },
                { text: this.$t('guides.destination'), align: "center", value: 'destination', class: 'text-uppercase' },
                { text: this.$t('guides.label_downloaded'), align: "center", value: 'label_downloaded', class: 'text-uppercase' },
                { text: this.$t('guides.actions'), align: "center", value: 'actions', class: 'text-uppercase' },
            ];
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            props: {
                search: '',
                items: [],
                meta: {
                    total: null,
                    total_pages: null,
                    per_page: null,
                    page: null
                },
                sort_by: []
            },
            modal_massive: false,
            modal_delete: false,
            modal_cancel: false,
            stepper: 1,
            stepper_delete: 1,
            stepper_cancel: 1,
            cancel_reason: "",
            inputFile: [],
            readFile2: '',
            readRows2: [],
            responses: [],
            load_addresses: false,
            addresses: [],
            load_subclients: false,
            subclients: [],
            orders: [],
            deletions: 0,
            cancelations: 0,
            guide: {
                client_id: 1,
                shipping_guide: {
                    client_reference_id: "",
                    subclient_id: "",
                    pickup_address_id: "",
                    recipient: {
                        contact: {
                            person_name: "",
                            phone_number: ""
                        },
                        address: {
                            street_lines: ["",""],
                            municipality: "",
                            state: "",
                            postal_code: "",
                            country: "",
                            comments: ""
                        }
                    },
                    package_items: []
                }
            },
            tab: null,
            global_status: "created",
            tab_items: [this.$t('guides.created'), this.$t('guides.in_transit'), this.$t('guides.delivered'), this.$t('guides.returned')],
            items_selected_created: [], 
            items_selected_in_transit: [], 
            items_selected_delivered: [], 
            items_selected_returned: [], 
            debounceTimer: null,
            pagination: {
                pendings: { page: 1, itemsPerPage: 20, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false },
                in_transit: { page: 1, itemsPerPage: 20, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false },
                delivered: { page: 1, itemsPerPage: 20, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false },
                returned: { page: 1, itemsPerPage: 20, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false }
            } // current page and per page of each table
        }
    },
    mounted(){
        this.$store.state.module = "headers.guides";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async loadData(status){
            try {
                if(this.$store.state.clientId == null && this.$store.state.clientId == undefined) return; 

                var response = null
                
                if (this.tab == 0) response = await indexByClientGuidesUseCase(this.$store.state.clientId, this.pagination.pendings.itemsPerPage, this.pagination.pendings.page, status, this.props.search, this.props.sort_by, HttpGuideRepository);
                else if (this.tab == 1) response = await indexByClientGuidesUseCase(this.$store.state.clientId, this.pagination.in_transit.itemsPerPage, this.pagination.in_transit.page, status, this.props.search, this.props.sort_by, HttpGuideRepository);
                else if (this.tab == 2) response = await indexByClientGuidesUseCase(this.$store.state.clientId, this.pagination.delivered.itemsPerPage, this.pagination.delivered.page, status, this.props.search, this.props.sort_by, HttpGuideRepository);
                else if (this.tab == 3) response = await indexByClientGuidesUseCase(this.$store.state.clientId, this.pagination.returned.itemsPerPage, this.pagination.returned.page, status, this.props.search, this.props.sort_by, HttpGuideRepository);

                this.props.items = response.data.success.arguments.data;
                this.props.meta = response.data.success.arguments.meta;
            } catch (e) {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async onOptionsChange(options) {
            if (this.tab == 0) this.pagination.pendings = options;
            else if (this.tab == 1) this.pagination.in_transit = options;
            else if (this.tab == 2) this.pagination.delivered = options;
            else if (this.tab == 3) this.pagination.returned = options;

            if(options.sortBy.length > 0){
                this.props.meta.page = 1;
                this.props.sort_by = [{field: options.sortBy[0], direction: options.sortDesc[0] ? 'desc' : 'asc'}];
            } 
            else if(options.sortBy.length != this.props.sort_by.length) {
                this.props.meta.page = 1;
                this.props.sort_by = [];
            } 

            this.loadData(this.global_status);
        },
        createWithCsv(){
            this.createInput2(this.inputFile);
        },
        createInput2(file) {
            const promise = new Promise((resolve) => {
                const reader = new FileReader();
                // const vm = this;
                reader.onload = () => {
                    resolve((this.readFile = reader.result));
                };
                reader.readAsText(file);
            });

            promise.then(
                result => {
                    /* handle a successful result */
                    this.readRows2 = result.split('\r\n');
                    this.sTHeaders2 = this.readRows2[0].split(',');
                    this.readRows2.shift();
                    this.createGuides();
                },
                error => {
                    /* handle an error */ 
                    console.log(error);
                }
            );
        },
        async createGuides(){
            if(this.readRows2.length > 0){
                var count = 1

                for(const x of this.readRows2){
                    if(x != ""){
                        const num = x.split(',');
                        
                        if(num[14].split('|').length == num[15].split('|').length){
                            this.guide.shipping_guide.client_reference_id = this.uuidv4();
                            
                            if(num[16] != null && num[16] != undefined) {
                                if(num[16].trim() != ""){
                                    this.guide.shipping_guide.shipper =  {
                                        "company_name": num[16]
                                    };
                                }
                            }

                            this.guide.shipping_guide.recipient = {
                                contact: {
                                    person_name: num[0],
                                    phone_number: num[8]
                                },
                                address: {
                                    street_lines: [num[5].toString(), num[4]],
                                    municipality: num[3],
                                    state: num[2],
                                    postal_code: num[6],
                                    country: num[1],
                                    comments: num[9]
                                }
                            };

                            this.guide.shipping_guide.package_items = [];
                            for( var i = 0; i < num[14].split('|').length; i++ ){
                                this.guide.shipping_guide.package_items.push({
                                    "reference": num[14].split('|')[i],
                                    "declared_value_mxn": num[15].split('|')[i],
                                    "weight_kg": num[13], // 19.2
                                    "dimensions_cm": {
                                        "length": num[10], //40
                                        "width": num[11], // 40
                                        "height": num[12] //60
                                    }
                                });
                            }

                            try {
                                const response = await createGuideUseCase(this.guide, HttpGuideRepository);
                                for(var guide in response.data.attributes.details){
                                    this.responses.push({
                                        order: guide.reference,
                                        message: this.$t('guides.guide_created')
                                    })
                                }
                            }
                            catch(e) {
                                console.log(e)
                                this.responses.push({
                                    order: count,
                                    message: e.response.data.fault.message
                                });
                            }
                        }
                        else {
                            this.responses.push({
                                order: count,
                                message: this.$t("orders.wrong_details")
                            });
                        }

                        count++;
                    }
                }

                this.stepper = 2;
            }
            else{
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('upload_annex.validations.select_file_first')
                };
            }
        },
        uuidv4() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },
        async handleSelected(value, type){
            if(type == "created") this.items_selected_created = value;
            else if(type == "in_transit") this.items_selected_in_transit = value;
            else if(type == "delivered") this.items_selected_delivered = value;
            else if(type == "returned") this.items_selected_returned = value;
        },
        async downloadLabels(){
            var current_selected_items = [];
            var zip = new JSZip();

            if(this.tab == 0) current_selected_items = this.items_selected_created;
            else if(this.tab == 1) current_selected_items = this.items_selected_in_transit;
            else if(this.tab == 2) current_selected_items = this.items_selected_delivered;
            else if(this.tab == 3) current_selected_items = this.items_selected_returned;

            var ids = current_selected_items.map(x => x.id)

            try {
                const response = await downloadGuidesUseCase(ids, HttpGuideRepository);
                
                for(let item of response.data.data){
                    const {data} = await getGuideBlobUseCase(item.attributes.download_label_path, HttpGuideRepository);

                    zip.file(item.attributes.reference +'.png', data);
                }

                zip.generateAsync({type:"blob"}).then(function(content) {
                    FileSaver.saveAs(content, "labels.zip")
                }, function(err){
                    console.log(err)
                })           
                
                this.loadData(this.global_status)
            } catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async calculateDeletions(){
            if(this.tab == 0) this.deletions = this.items_selected_created.length;
            else if(this.tab == 1) this.deletions = this.items_selected_in_transit.length;
            else if(this.tab == 2) this.deletions = this.items_selected_delivered.length;
            else if(this.tab == 3) this.deletions = this.items_selected_returned.length;

            if(this.deletions > 0) this.modal_delete = true;
            else {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('guides.nothing_selected')
                }
            }
        },
        async calculateCancelations(){
            if(this.tab == 0) this.cancelations = this.items_selected_created.length;
            else if(this.tab == 1) this.cancelations = this.items_selected_in_transit.length;
            else if(this.tab == 2) this.cancelations = this.items_selected_delivered.length;
            else if(this.tab == 3) this.cancelations = this.items_selected_returned.length;

            if(this.cancelations > 0) this.modal_cancel = true;
            else {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('guides.nothing_selected_cancel')
                }
            }
        },
        async deleteShippingGuidesDetails(){
            var current_selected_items = [];

            if(this.tab == 0) current_selected_items = this.items_selected_created;
            else if(this.tab == 1) current_selected_items = this.items_selected_in_transit;
            else if(this.tab == 2) current_selected_items = this.items_selected_delivered;
            else if(this.tab == 3) current_selected_items = this.items_selected_returned;

            var ids = current_selected_items.map(x => x.id)

            try {
                const response = await deleteShippingGuidesUseCase(ids, HttpGuideRepository);
                this.responses = response.data;

                this.stepper_delete = 2;

            } catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async cancelShippingGuidesDetails(){
            var current_selected_items = [];

            if(this.tab == 0) current_selected_items = this.items_selected_created;
            else if(this.tab == 1) current_selected_items = this.items_selected_in_transit;
            else if(this.tab == 2) current_selected_items = this.items_selected_delivered;
            else if(this.tab == 3) current_selected_items = this.items_selected_returned;
            var ids = [];

            for(var item of current_selected_items){
                ids.push({ id: item.id, reason: this.cancel_reason });
            }

            try {
                const response = await cancelShippingGuidesUseCase({ shipping_guide_details: ids }, HttpGuideRepository);
                this.responses = response.data;

                this.stepper_cancel = 2;

            } catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async updateGuides(){
            if(this.$store.state.clientId != null && this.$store.state.clientId != "all"){
                console.log("Refresh");
            }
            else {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('guides.no_client_selected')
                }
            }
        }
    },
    watch: {
        '$store.state.clientId': async function (){
            if(this.$store.state.clientId != null){
                this.subclients = [];
                this.addresses = [];
                this.load_addresses = true;
                this.load_subclients = true;

                this.guide.client_id = this.$store.state.clientId;

                const subclients = await indexSubclientsUseCase(this.$store.state.clientId, HttpSubclientRepository);
                this.subclients = subclients;
                
                const pickup_addresses = await indexPickupAddressesUseCase(this.$store.state.clientId, HttpPickupAddressRepository);
                this.addresses = pickup_addresses;

                this.load_addresses = false;
                this.load_subclients = false;

                this.loadData(this.global_status);
            }
        },
        'tab': async function(){
            this.global_status = "created";
            
            if(this.tab == 0) this.global_status = 'created';
            else if(this.tab == 1) this.global_status = 'in_transit';
            else if(this.tab == 2) this.global_status = 'delivered';
            else if(this.tab == 3) this.global_status = 'returned';
            else this.global_status = 'created';

            this.loadData(this.global_status);
        },
        'props.search': async function(){
            clearTimeout(this.debounceTimer)

            this.debounceTimer = setTimeout(() => {
                this.loadData(this.global_status);
            }, 800);
        }
    }
}
</script>

<style>

</style>